import React from 'react'
import ProductSlider from './ProductSlider';
import { useParams } from 'react-router-dom';
import { featureddata } from '../DUMMYDATA/DUMMYDATA'

const ProductDetail = () => {
    const { id, proid } = useParams();

    const featuredProduct = featureddata.find((category) => category.id === Number(id));
  
    if (!featuredProduct) {   
      return <div>Category not found</div>;
    }
  
    const specificProduct = featuredProduct.featureddata.find((product) => product.id === Number(proid));
  
    if (!specificProduct) {    
      return <div>Specific product not found</div>;
    }
  return (
    <section className='flex md:flex-row max-sm:flex-col w-full mb-4  mt-[6.75rem] gap-0'>
        <div id="left" className='pt-36 md:w-[50%] md:h-[] max-sm:w-[93%] justify-center md:pl-[48px] '>
            
           <ProductSlider/>
            
        </div>
        <div id="right" className='md:w-[50%] max-sm:w-[100%] pt-[109px] max-sm:px-6'>
            <h1 className='font-semibold text-4xl pb-4 max-sm:text-[27px] '>{specificProduct.heading}</h1>
            <p className='pb-3'>"Be like a Diamond, precious and rare not like a stone that is found everywhere"</p>
            <p className='pb-5 w-[60%] text-[18px] max-sm:w-full'>The Love for Life bangle is quite simply a celebration of love. Catherine saw the diamond as the spark of life and the ring for eternal safety, while the precious metal represents timelessness and the heart symbolising Love. Unique and extremely sentimental this bangle is a beautiful and contemporary gift for the love of your life.</p>
            <table className='table-auto'>
                <thead className='font-semibold text-lg text-tertary2'>Details</thead>
                <tr>
                    <td className='p-4 font-semibold'>Precious Metal:</td>
                    <td className='p-4'>18ct Yellow and White Gold</td>
                </tr>
                <tr>
                    <td className='p-4 font-semibold'>Gemstone:</td>
                    <td className='p-4'>Diamond</td>
                </tr>
                <tr>
                    <td className='p-4 font-semibold'>Diamond Specification:</td>
                    <td className='p-4'>5.39ct G Colour Vs Clarity</td>
                </tr>
                <tr>
                    <td className='p-4 font-semibold'>Limited Edition:</td>
                    <td className='p-4'>10</td>
                </tr>
                <tr>
                    <td className='p-4 font-semibold'>Product Code:</td>
                    <td className='p-4'>Bcf98057po</td>
                </tr>

            </table>
            <div className='mb-7'>
            <h3 className='font-semibold text-lg pb-3 text-tertary2'>Enquiries</h3>
            <p className='w-[70%] pb-4 max-sm:w-full'>For further details, please visit your nearest our Jewellery store, or enquire with Jewellery Customer Service</p>
            <p>or<b> call 0987 6578 09 </b> (Business Hours : Mon - Sat 10:00 - 18:00).</p>
        </div>
        </div>
        
    </section>
  )
}

export default ProductDetail
